import VisualizarContaCartaoModal from './VisualizarContaCartaoModal';

export default VisualizarContaCartaoModal;
